import { render, staticRenderFns } from "./NewsRead.vue?vue&type=template&id=ee453f10&scoped=true"
import script from "./NewsRead.vue?vue&type=script&lang=js"
export * from "./NewsRead.vue?vue&type=script&lang=js"
import style0 from "./NewsRead.vue?vue&type=style&index=0&id=ee453f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee453f10",
  null
  
)

export default component.exports